import React, { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import CustomAlert from '@common/components/Feedback/CustomAlert';
import { useAppDispatch, useAppSelector } from '../../store';
import { selectAnnouncementsData } from '../../store/service/service-slice-selectors';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import { getAnnouncements } from '../../store/service/service-actions';
import { selectUser } from '../../store/general/general-slice-selectors';
import { fetchSeenAnnouncementIds, setSeenAnnouncementId } from 'store/service/service-slice';

const AnnouncementBanner: React.FC = () => {
  const dispatch = useAppDispatch();

  const announcementsData = useAppSelector((state) => selectAnnouncementsData(state));
  const userData = useAppSelector((state) => selectUser(state));

  useEffect(() => {
    if (announcementsData.seenAnnouncementIds == null) {
      dispatch(fetchSeenAnnouncementIds());
    }
  }, [announcementsData.seenAnnouncementIds, dispatch]);

  useEffect(() => {
    if (announcementsData.rest.getStatus === HttpFetchStatus.Idle) {
      dispatch(getAnnouncements());
    }
  }, [announcementsData.rest.getStatus, dispatch]);

  const closeAnnouncementClickHandler = (id: string) => {
    dispatch(setSeenAnnouncementId(id));
  };

  const filteredAnnouncements = announcementsData.data?.filter((announcement) =>
    announcementsData.seenAnnouncementIds == null
      ? false
      : !announcementsData.seenAnnouncementIds.includes(announcement.id),
  );

  if (filteredAnnouncements == null || filteredAnnouncements.length === 0) return null;

  return (
    <React.Fragment>
      <Stack spacing={1} width="100%">
        {filteredAnnouncements.map((announcement) => (
          <CustomAlert
            key={announcement.id}
            header={
              announcement.localizations.find((l) => l.language === userData.data.language)?.text ??
              announcement.text
            }
            severity={announcement.severity}
            variant="filled"
            onClose={() => closeAnnouncementClickHandler(announcement.id)}
          />
        ))}
      </Stack>
    </React.Fragment>
  );
};

export default AnnouncementBanner;
